/**
 * PRODUCTION environement
 *
 * run locally: ng serve --configuration="prod"
 *
 * build for deployment: npm run build-for-prod
 */

const api_zuul_server = "https://apis.tunify.com";

//see environment.ts file for more info
export const environment = {
  name: 'PROD',
  firebase: {
    projectId: 'tunify-player',
    appId: '1:443747435615:web:7bcecf05ef59f5f02747ea',
    databaseURL: 'https://tunify-player.firebaseio.com',
    storageBucket: 'tunify-player.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyADQms--hZnyYe137XwTRFZTk0Bmhnc1X0',
    authDomain: 'tunify-player.firebaseapp.com',
    messagingSenderId: '443747435615',
    measurementId: 'G-4NZCR7T4R6',
  },
  production: true,
  consoleLogLevel: "warn",
  webServiceLogLevel: "warning",

  use_redirect_location: true,
  build_version: "5",
  redirect_location_v5: "https://player.tunify.com",
  redirect_location_v4: "https://player-v4.tunify.com",

  default_version: "5",
  default_v4_allowed: false,
  default_v5_allowed: true,

  desktopAppGeneralLocation: 'https://dl.todesktop.com/200219qjgudgp5o',
  desktopAppMacx64Location: 'https://dl.todesktop.com/200219qjgudgp5o/mac/dmg/x64',
  desktopAppMacarm64Location: 'https://dl.todesktop.com/200219qjgudgp5o/mac/dmg/arm64',
  desktopAppWindowsLocation: 'https://dl.todesktop.com/200219qjgudgp5o/windows/nsis/x64',
  desktopAppLinuxLocation: 'https://dl.todesktop.com/200219qjgudgp5o/linux/appImage/x64',
  desktopProtocol: 'tunify://',
  desktopPorts: [22445, 39214],

  mockBackend: false,
  VERSION: require('../../package.json').version,
  mockQueue: false,
  mockRadioQueue: false,
  mockSearch: false,
  enableSoundSpectrum: true,
  enableXMLHttpRequest: false,
  useAudioTagForFastStart: true,
  logChangeDetection: false,


  allowMultipleLogin: true,
  loginWithoutSubscription: false,

  enableGreen: true,
  enableOrange: true,

  enableSearch: true,
  enableOnScreenKeyboard: false,
  enableSongRequests: true,
  enableRecommendations: true,

  enableLinkToBrowserFromDesktopApp: true,
  enableDownloadApp: true,
  enableHome: false,

  testMultipleZoneConnections: false,

  previousVersionUrl: "https://www.tunify.com/tunify/open-player.html?v=3",

  otherVersionUrl: "https://player.tunify.com",

  mytunifyBaseUrl: "https://my.tunify.com",
  helpGreen: "https://www.tunify.com/open/demo-tunify-green",
  helpBlue: "https://www.tunify.com/open/demo-tunify-blue",
  helpOrange: "https://www.tunify.com/open/demo-tunify-orange",
  helpConnect: "https://www.tunify.com/open/player-code",
  mytunifyRegister: "https://my.tunify.com/register",

  api_authenticator: api_zuul_server, //zuul recognizes the endpoints and forwards to the authentication service
  api_md5_authenticator: api_zuul_server + "/t4-md5-authenticator",
  api_music_service: api_zuul_server + "/t4-music-service",
  api_logging_service: api_zuul_server + "/t4-logging-service",
  api_media_service: api_zuul_server + "/t4-media-service",
  api_subscriptions_service: api_zuul_server + "/t4-subscriptions-service",
  api_song_requests_service: api_zuul_server + "/t4-song-requests-service",
  api_zone_service: api_zuul_server + "/t4-zone-service",
  api_brands_service: api_zuul_server + "/t4-brands-service",
  api_recommender_service: api_zuul_server + "/t4-recommender-service",

  api_remoteControl: "https://comm.tunify.com:443/",

  api_SOAP_webservice: "https://api.tunify.com/blackbox2/services/tunify3/",
  api_SOAP_logging: "https://api.tunify.com/blackbox2/services/tunify_logging/",

  appId: '60',
  appPassword: 'TyQQ3MmPavTzPvt2',
  api_appPassword: 'tunHTML',

  enableIntercom: true,
  enableIntercomMessenger: true,
  intercomId: "bh3blita",

  enableAbly: true,
  ablyKey: 'HQGNYA.gznHow:SXW_E3MDUC_ptmv6'
};
